import React, {useEffect, useState} from 'react';
import {createRoot} from 'react-dom/client';
import DrupalAccessTokenApi from "../../../js/csf/DrupalAccessTokenApi";
import {startLoadingSpinner, stopLoadingSpinner} from '../../csf-ufc-pivotal/includes/utils';

import {CsfPivotalFournisseurRecognitionLastRequest} from "./csf-fournisseur-recognition-last-request";
import {CsfPivotalFournisseurRecognitionHistory} from "./csf-fournisseur-recognition-history";
import {CsfPivotalFournisseurRecognitionDetails} from "./csf-fournisseur-recognition-details";
import {
  CsfPivotalFournisseurRecognitionDetailConfirmation
} from "./csf-fournisseur-recognition-detail-print-confirmation";
import {CsfPivotalFournisseurRecognitionDetailPrint} from "./csf-fournisseur-recognition-detail-print";
import {CsfPivotalFournisseurEventModification} from "../csf-fournisseur-home/csf-fournisseur-event-modification";

import PropTypes from "prop-types";
// import style
import './csf-fournisseur-recognition-detail.scss';
import PivotalFormApi from "../../../js/csf/pivotal/PivotalFormApi";
import PivotalSearchApi from "../../../js/csf/pivotal/PivotalSearchApi";
import {getQueryParams} from "../includes/utils";

export function CsfPivotalFournisseurRecognitionDetail({apiUrl, apiEnv, urlRequestRecognition, urlList}) {
  const [accessToken, setAccessToken] = useState('');
  const [trainingId, setTrainingId] = useState('');
  const [formDetail, setFormDetail] = useState({});
  const [contact, setContact] = useState({});
  const [trainingConfirmation, setTrainingConfirmation] = useState({});
  const [formHistory, setFormHistory] = useState([]);
  const [formLastRequest, setFormLastRequest] = useState([]);
  const [trainers, setTrainers] = useState([]);
  const [trainingUfcInfo, setTrainingUfcInfo] = useState({});
  const [allMatiereInfo, setAllMatiereInfo] = useState([]);
  const [trainingInfoPrint, setTrainingInfoPrint] = useState({});
  const [trainingUFCPrintScreen, setTrainingUFCPrintScreen] = useState({});
  const [lastReduCycleId, setLastReduCycleId] = useState('');
  const [trainingIdPrint, setTrainingIdPrint] = useState('');


  /*
  * On components mounts fetch the user access token only once.
  * */
  useEffect(() => {
    startLoadingSpinner();
    const params = getQueryParams(window.location.search);
    if (params && params.activity) {
      setTrainingId(params.activity);
    }
    fetchAccessToken();
  }, []);

  /*
  * When the accessToken is fetched and state is updates, get the training info
  * */
  useEffect(() => {
    if (accessToken !== '') {
      stopLoadingSpinner();
      getTrainingInfo();
      getTrainingHistory();
    }
  }, [accessToken]);

  /*
  * when the training info s fetched call the others api call that ar dependent on the training
  * */
  useEffect(() => {
    if (Object.keys(formDetail).length !== 0 && trainingId !== '') {
      getPrimaryContact();
      getTrainingHistory();
      getInformationPrintScreen();
      getMatiereInfo();
    }
  }, [formDetail]);

  /*
  * when the training info is fetch get the REDU_Last_Cycle_ID to fetch the subject of the training
  * */
  useEffect(() => {
    if (lastReduCycleId !== '') {
      getTrainingUfc();
    }
  }, [lastReduCycleId]);

  /*
 * Call to get the info of the training to print
 * */
  useEffect(() => {
    if (trainingIdPrint !== '') {
      getConfirmationPrintScreen(trainingIdPrint);
      getTrainingUfcPrinting(trainingIdPrint);
    }
  }, [trainingIdPrint]);

  /*
  * Method to call drupal api to get the access token of the session.
  * */
  function fetchAccessToken() {
    const drupalAccessTokenApi = new DrupalAccessTokenApi();
    drupalAccessTokenApi.fetchPostRequest('fournisseur')
      .then(response => {
        if (response?.api_access_token) {
          setAccessToken(response.api_access_token);
        } else {
          stopLoadingSpinner();
        }
      })
      .catch(error => {
        stopLoadingSpinner();
        console.error(error);
      });
  }

  /*
  * Method to get all the training info
  * */
  function getTrainingInfo() {
    const requestData = {
      form: 'CSF_EP_UXRecognition_Info',
      recordId: trainingId
    };
    const pivotalFormApi = new PivotalFormApi(apiUrl, apiEnv, accessToken);
    pivotalFormApi.callFormRecuperationEndpoint(requestData, '_Espace_Partenaire')
      .then(response => {
        if (response?.success && response?.payload?.data?.primary) {
          setFormDetail(response.payload.data.primary);
          setLastReduCycleId(response.payload.data.primary.Last_REDU_Cycle_Id);
          setTrainers(response.payload.data.primary.Formateur__Secondary);
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  /*
  * Method to get contact person info
  * */
  function getPrimaryContact() {
    const requestData = {
      form: 'CSF_EP_UXContact_Info',
      recordId: formDetail.Contact_Id,
    };
    const pivotalFormApi = new PivotalFormApi(apiUrl, apiEnv, accessToken);
    pivotalFormApi.callFormRecuperationEndpoint(requestData, '_Espace_Partenaire')
      .then(response => {
        if (response?.success && response?.payload?.data?.primary?.Contact_Id) {
          setContact(response.payload.data.primary);
        }
      })
      .catch(error => {
        stopLoadingSpinner();
        console.error(error);
      });
  }

  /*
  * Method to get all the history info of a training.
  * */
  function getTrainingHistory() {
    const requestData = {
      form: 'CSF_EP_HistoryCycle_REST',
      recordId: trainingId,
    };
    const pivotalFormApi = new PivotalFormApi(apiUrl, apiEnv, accessToken);
    pivotalFormApi.callFormRecuperationEndpoint(requestData, '_Espace_Partenaire')
      .then(response => {
        if (response?.success && response?.payload?.data?.primary?.History__Secondary) {
          const allHistory = response.payload.data.primary.History__Secondary;
          setFormLastRequest(allHistory[0]);

          if (allHistory[0].REDU_Status_Activity_Id === "AAAAAAAAABE=" || //01- Brouillon
            allHistory[0].REDU_Status_Activity_Id === "AAAAAAAAABM=" || //02- En analyse
            allHistory[0].REDU_Status_Activity_Id === "AAAAAAAAADE=") {  //03- En attente d'informations
            const allHistoryWithoutLatest = allHistory.slice(1);
            setFormHistory(allHistoryWithoutLatest);
          } else {
            setFormHistory(allHistory);
          }
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  /*
  * Method to get all the history info of a training.
  * */
  function getTrainingUfc() {
    const requestData = {
      form: 'CSF_UXMatiere_Info',
      recordId: lastReduCycleId
    };

    const pivotalFormApi = new PivotalFormApi(apiUrl, apiEnv, accessToken);
    pivotalFormApi.callFormRecuperationEndpoint(requestData, '_Espace_Partenaire')
      .then(response => {
        if (response?.success && response?.payload?.data?.primary) {
          setTrainingUfcInfo(response.payload.data.primary);
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  /*
 * Method to get all the history info of a training.
 * */
  function getTrainingUfcPrinting(idTraining) {
    const requestData = {
      form: 'CSF_UXMatiere_Info',
      recordId: idTraining
    };

    const pivotalFormApi = new PivotalFormApi(apiUrl, apiEnv, accessToken);
    pivotalFormApi.callFormRecuperationEndpoint(requestData, '_Espace_Partenaire')
      .then(response => {
        if (response?.success && response?.payload?.data?.primary) {
          setTrainingUFCPrintScreen(response.payload.data.primary);
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  function getMatiereInfo() {
    const requestData = {
      search: 'CSF_EP_Subjects_REST',
      searchResultsList: 'CSF_EP_Subjects_SRL',
      ParameterValues: [""]
    };
    const pivotalSearchApi = new PivotalSearchApi(apiUrl, apiEnv, accessToken);
    pivotalSearchApi.callSearchEndpoint(requestData, '_Espace_Partenaire')
      .then(response => {
        if (response?.success && response?.payload?.data?.rows) {
          setAllMatiereInfo(response.payload.data.rows);
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  /*
* Method to get all the training info
* */
  function getConfirmationPrintScreen(trainingIdToPrint) {
    const requestData = {
      form: 'CSF_EP_UXImpressionConfirm_Info',
      recordId: trainingIdToPrint
    };
    const pivotalFormApi = new PivotalFormApi(apiUrl, apiEnv, accessToken);
    pivotalFormApi.callFormRecuperationEndpoint(requestData, '_Espace_Partenaire')
      .then(response => {
        if (response?.success && response?.payload?.data?.primary) {
          setTrainingConfirmation(response.payload.data.primary);
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  /*
* Method to get all the training info
* */
  function getInformationPrintScreen() {
    const requestData = {
      form: 'CSF_EP_UXImpression_Info',
      recordId: trainingId
    };
    const pivotalFormApi = new PivotalFormApi(apiUrl, apiEnv, accessToken);
    pivotalFormApi.callFormRecuperationEndpoint(requestData, '_Espace_Partenaire')
      .then(response => {
        if (response?.success && response?.payload?.data?.primary) {
          setTrainingInfoPrint(response.payload.data.primary);
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  function goBackEvent() {
    window.history.back();
  }

  return (
    <main id="fournisseur-recognition-detail" className="fournisseur">
      <div className="non-print-wrapper">
        <div className="header-wrapper">
          <h1>
            {formDetail.Name_French}
            {formDetail.Name_French !== null ? (
              <span>{formDetail.Name_English}</span>
            ) : (
              formDetail.Name_English
            )}
          </h1>
        </div>

        <div className="row">
          <div className="col col-lg-5 p-1">
            <CsfPivotalFournisseurRecognitionLastRequest
              formDetail={formDetail}
              urlRequestRecognition={urlRequestRecognition}
              formLastRequest={formLastRequest}
              accessToken={accessToken}
              apiUrl={apiUrl}
              apiEnv={apiEnv}
              urlList={urlList}
            />

            <CsfPivotalFournisseurRecognitionHistory
              formHistory={formHistory}
              setTrainingIdPrint={setTrainingIdPrint}
            />

            <div className="text-center">
              <button onClick={goBackEvent} className="button btn-larger" type="button">
                {window.Drupal.t('fournisseur.previous.btn')}
              </button>
            </div>
          </div>

          <div className="col col-lg-7 p-1">
            <CsfPivotalFournisseurRecognitionDetails
              formDetail={formDetail}
              contact={contact}
              trainers={trainers}
              trainingUfcInfo={trainingUfcInfo}
              allMatiereInfo={allMatiereInfo}
              accessToken={accessToken}
              apiUrl={apiUrl}
              apiEnv={apiEnv}
            />
          </div>
        </div>
      </div>

      <CsfPivotalFournisseurRecognitionDetailConfirmation
        trainingConfirmation={trainingConfirmation}
        trainingUfcInfo={trainingUFCPrintScreen}
        allMatiereInfo={allMatiereInfo}
      />

      <CsfPivotalFournisseurRecognitionDetailPrint trainingUfcInfo={trainingUfcInfo} allMatiereInfo={allMatiereInfo}
                                                   trainingInfoPrint={trainingInfoPrint}/>

      <CsfPivotalFournisseurEventModification/>
    </main>
  );
}

window.addEventListener('DOMContentLoaded', () => {
  const domNode = document.getElementById('CsfPivotalFournisseurRecognitionDetail');
  if (domNode !== null) {
    const root = createRoot(domNode);

    const apiUrl = domNode.getAttribute("data-api-url");
    const apiEnv = domNode.getAttribute("data-api-env");
    const urlRequestRecognition = domNode.getAttribute("data-url-request-recognition");
    const urlList = domNode.getAttribute("data-url-list");

    root.render(<CsfPivotalFournisseurRecognitionDetail
      apiUrl={apiUrl}
      apiEnv={apiEnv}
      urlRequestRecognition={urlRequestRecognition}
      urlList={urlList}
    />);
  }
});

CsfPivotalFournisseurRecognitionDetail.propTypes = {
  apiUrl: PropTypes.string,
  apiEnv: PropTypes.string,
  urlRequestRecognition: PropTypes.string,
  urlList: PropTypes.string
};
